import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { circle, icon, latLng, map, marker, polygon, popup, tileLayer } from 'leaflet';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2'
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { TrackerService } from 'src/app/services/data/tracker.service';
import { MapService } from 'src/app/services/map/map.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, AfterViewInit {

  baseUrlPublic: string;
  dialogRef: MatDialogRef<any>;
  options = {
    zoomControl: false,
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: 'SpotTracker © 2021' })
    ],
    zoom: 9,
    center: latLng(43.35, 13.0)
  };
  constructor(
    public dialog: MatDialog,
    private trackerService: TrackerService,
    private mapService: MapService
  ) {
    this.baseUrlPublic = environment.baseUrlPublic;
  }

  ngAfterViewInit() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });

    Toast.fire({
      icon: 'success',
      title: 'Signed in successfully'
    })
  }


  ngOnInit(): void {
    this.trackerService.getLastPositionPerTracker(sessionStorage.getItem('region'))
      .subscribe((res: any) => {
        for (let i = 0; i < res.length; i++) {
          this.mapService.createMarker(res[i].data, "");
        }
      })
  }

  onMapReady(map) {
    this.mapService.setMap(map);
  }
}
